var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccountEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58337 3.5C1.89327 3.5 1.33337 4.0599 1.33337 4.75C1.33337 5.14323 1.51827 5.51302 1.83337 5.75L7.50004 10C7.79692 10.2214 8.20317 10.2214 8.50004 10L14.1667 5.75C14.4818 5.51302 14.6667 5.14323 14.6667 4.75C14.6667 4.0599 14.1068 3.5 13.4167 3.5H2.58337ZM1.33337 6.41667V11.8333C1.33337 12.7526 2.08077 13.5 3.00004 13.5H13C13.9193 13.5 14.6667 12.7526 14.6667 11.8333V6.41667L9.00004 10.6667C8.40629 11.112 7.59379 11.112 7.00004 10.6667L1.33337 6.41667Z",
    fill: "#6D738D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountEmail);
export default __webpack_public_path__ + "static/media/my_account_email.d11e8d344d21edc9b64c1480c1809b3d.svg";
export { ForwardRef as ReactComponent };